export default "__VITE_ASSET__CLYAy0l0__"